// Preorder products carry a "Fecha de lanzamiento: <date>" line at the end of
// the description (merchant-entered). Pull it out and show it as a prominent
// notice directly under the add-to-cart button, so it's obvious the item
// ships after that date.
(function () {
  var btns = document.querySelector('.product-form__buttons');
  var desc = document.querySelector('.product__description');
  if (!btns || !desc) return;

  var re = /fecha de lanzamiento/i;
  var node = null;
  var candidates = desc.querySelectorAll('span, p, li, div');
  for (var i = 0; i < candidates.length; i++) {
    if (re.test(candidates[i].textContent) && candidates[i].querySelectorAll('*').length === 0) {
      node = candidates[i];
      break;
    }
  }
  if (!node) return;

  var text = node.textContent.trim();
  var parent = node.parentElement;
  node.remove();
  // Drop the wrapping <p> if it's now empty.
  if (parent && parent.tagName === 'P' && parent.textContent.trim() === '') parent.remove();

  var box = document.createElement('div');
  box.className = 'kodama-release';
  var icon = document.createElement('span');
  icon.className = 'kodama-release__icon';
  icon.setAttribute('aria-hidden', 'true');
  icon.textContent = '📅';
  var label = document.createElement('span');
  label.textContent = text;
  box.appendChild(icon);
  box.appendChild(label);

  btns.insertAdjacentElement('afterend', box);
})();
